export default "__VITE_ASSET__BMjxfxa7__"